import React from "react";
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import {  Button } from 'antd';
import '../card.css';
import axios from 'axios';
import "react-notifications-component/dist/theme.css";
import i18n from '../i18n';
import {connect} from 'react-redux';
import Menutest from './menu.js';
import {Checkbox} from 'semantic-ui-react';
import Select from "react-select";
import {reactLocalStorage} from 'reactjs-localstorage';
import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import ReactPhoneInput from 'react-phone-input-2';
import Modal from 'react-modal';
import { API_BASE_URL } from "../utils/endpoints";


const customStylesstop = {
  content : {
    width               : '40%',
    marginRight         : '30%',
    marginLeft          : '30%',
    height              :'231px',
    marginTop           :'6%',
    background          :' #fcfcfc !important'
  }
};
var senders=[]
var countryOptions = []
var balance_type=[]
  class AddForm extends React.Component {
    state = {
      firstName: '',
      lastName: '',
      email: '',
      password:'',
      account_status:true,
      expiry:'',
      mobile_number:'',
      land_line:'',
      weight:'',
      type: [
       { label: "Bulk SMS", value: "bulk" },
       { label: "Profiled SMS", value: "profiled" },
       { label: "LBA SMS", value: "lba" },
       { label: "Survey SMS", value: "survey" },
       { label: "International SMS", value: "international" },
       
   ],
           typeselect:'',
           balance:0,
           senderidselect:'',
           options_sender:[],
           user_id:[],
           expiry_data:'',
           code:'',
           enable:true,
           enable2:true,
           expiry_data_balance:'',
           userName:'',
           showsub:false,
           isArabic:false,
           modalIsOpen: false,
           user_ids:'',
           superOperator:false

   }

    constructor(props) {
      super(props);

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  openModal() {
    this.setState({modalIsOpen: true});
  }

  afterOpenModal() {
    this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({modalIsOpen: false});
    window.location="addsubadmin"
  }
    componentWillMount(){
      if(reactLocalStorage.get('role') ==='ROLE_ADMIN')
    {
      
     this.setState({showsub:true})
     
  
    }
      var token=reactLocalStorage.get('accessToken');
      var ip=API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if(ip.includes(s2))
      {
       apiBaseUrl =API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
       }
      else
      {
       apiBaseUrl = API_BASE_URL+"/core/user/rest/senderid/getSenderIds";  
      }
   
   
      
     
      var headers = {'Content-Type': 'application/json', 'token' :token }
   axios.get(apiBaseUrl,{headers: headers})
       .then(res => {
    
   
         if(res.data.result.sender_ids != undefined)
           {
             const senderidoption=res.data.result.sender_ids;
             var length=res.data.result.sender_ids.length;
             var i;
             const newArr = this.state.options_sender;
             for(i=0;i<length;i++)
             {
              var value_option=senderidoption[i].sender_id;

              newArr.push({
                 label: value_option, 
                 value:senderidoption[i].id
             });
               
             }
             this.setState({options_sender: res.data.result.sender_ids})

            

          
             
             countryOptions= newArr;
          }
        
        })
    }
    componentDidMount(){
      if (reactLocalStorage.get("role") === "ROLE_OPERATOR_INT") {
        this.setState({ superOperator: true });
      }
      var lang=i18n.language;
      if(lang ==="ar")
      {
        document.querySelector('.form_add_form').style = 'text-align:right;';       
        this.setState({isArabic:true})
      
      }
else
{
  this.setState({isArabic:false})
}

      var x=this;
      var token=reactLocalStorage.get('accessToken');
        
       var ip=API_BASE_URL;
       var s2 = "localhost:3000";
       var apiBaseUrl;
       if(ip.includes(s2))
       {
        apiBaseUrl =API_BASE_URL + "/core/user/rest/balance/getBalance/"+reactLocalStorage.get('user_id_login');
       }
       else
       {
        apiBaseUrl = API_BASE_URL+"/core/user/rest/balance/getBalance/"+reactLocalStorage.get('user_id_login');
       }
  
  
       var headers = {'Content-Type': 'application/json', 'token' :token }
       axios.get(apiBaseUrl,{headers: headers})
           .then(res => {
             if(res.data.result.ErrorDescription ==='user is not authenticated')
             {
                 window.location="/app";
             }
             else
             {
  
             
             const data = res.data.result.balances;
         var array=[]
         if(data != undefined){

         
             Object.keys(data).map(function(key) {
               if(key!='balance_general'){
             array.push({
                     label: key.replace(/_/g, ' '), 
                     value:key
                 }
             )}
             balance_type=array
             
          });
        }
            } 
            this.setState({code:''})
           })


        if(reactLocalStorage.get('role') ==='ROLE_OPERATOR')
        {
          
      document.querySelector('.green_color').innerText='Create Admin'
        }
    }
    handleChangeexpiry =event =>{
      this.setState({expiry_data:event.target.value});
  }
 
  handleChangebillingcode= event =>{
      this.setState({code:event.target.value});
  }
  handleChangeusername= event =>{
    this.setState({userName:event.target.value});
}
  enable =event =>{
      var mobile=event.target.id;
      if(this.state.enable === false){
          this.setState({enable:true});
      }
      else{
          this.setState({enable:false});
  }
}

enable2 =event =>{
  var mobile=event.target.id;
  if(this.state.enable2 === false){
      this.setState({enable2:true});
  }
  else{
      this.setState({enable2:false});
}
}
    onChangesenderid=(event)=> {
      var i;
      const newArray = this.state.user_id;
      for(i=0;i<event.length;i++)
      {
     
        if(newArray.includes(event[i].value) === false){
          newArray.push(event[i].value); 
        }
       
      }
   
      
    
      senders=newArray
     }
  
    handleChange = event => {
      this.setState({ firstName: event.target.value});

    }

    handleChangelname = event => {
      this.setState({ lastName: event.target.value});

    }
    

    handleChangeweight = event => {
      this.setState({ weight: event.target.value});

    }

    handleChangelandline = event => {
      this.setState({ land_line: event.target.value});

    }
    handleChangeexpiry = event => {
      this.setState({ expiry: event.target.value});

    }
    handleChangeaccount = event => {
      this.setState({ account_status: event.target.value});
    }
    
    handleChangepassword = event => {
      this.setState({ password: event.target.value});

    }
   
    handleChangeemail = event => {
      this.setState({ email: event.target.value});

    }
  

    handleSubmit = event => {
      event.preventDefault();

         
  //assign sender id
  
  const data2={
    'user_id':this.state.user_ids,
    'expiry': this.state.expiry_data_balance,
    'billing_code': this.state.code,
    'enable':true,
    'balance_type': this.state.typeselect,
    'balance_count': JSON.parse(this.state.balance),
  }
  var ip=API_BASE_URL;
  var token=reactLocalStorage.get('accessToken');
  var s2 = "localhost:3000";
  var apiBaseUrl;
  if(ip.includes(s2))
  {
    apiBaseUrl = API_BASE_URL + "/core/user/rest/balance/addBalance";
  }
  else
  {
   apiBaseUrl = API_BASE_URL+"/core/user/rest/balance/addBalance";
  }
  var headers = {
   'Content-Type': 'application/json',
   'token':token
    }
  axios.post(apiBaseUrl,data2,{headers: headers}).then(function (response)
  {

  if(response.status === 200)
  {
     if(response.data.status =='no sufficient balance'){
      toast({
        type: 'warning',
        title: i18n.t('warning.label'),
        description:'user created but'+' '+response.data.status,
        animation: 'bounce',
        time: 3000,
       
    });
     }
     else if(response.data.status == 'falid')
     {
      toast({
        type: 'warning',
        title: i18n.t('warning.label'),
        description: response.data.result.ErrorDescription,
        animation: 'bounce',
        time: 3000,
       
    });
     }
     if(response.data.status == 'success')
     {
       setTimeout(function(){ window.location="addsubadmin"; }, 3000);
     }
     
     
     



  }
  else if(response.status === 204){
  console.log("Something wrong");
  toast({
    type: 'error',
    title: i18n.t('error.label'),
    description:i18n.t('Something_wrong.label'),
    animation: 'bounce',
    time: 5000,

});


  }
  else{
  console.log("Something wrong");
  toast({
    type: 'error',
    title: i18n.t('error.label'),
    description:i18n.t('Something_wrong.label'),
    animation: 'bounce',
    time: 5000,

});

  }
  })
  .catch(function (error) {
  console.log(error);
  toast({
    type: 'error',
    title: i18n.t('error.label'),
    description:i18n.t('Something_wrong.label'),
    animation: 'bounce',
    time: 5000,

});
  });


      }


     
    

    back=()=>
    {
      window.location="addsubadmin";

    }
    enable =event =>{
      if(this.state.account_status === false){
          this.setState({account_status:true});
      }
      else{
          this.setState({account_status:false});
  }
}
onChangetype = values => {
  this.setState({typeselect:values.value});
  
}

handleChangebalance =event =>{
  this.setState({balance:event.target.value});
}
opentwo =(event)=>{
  event.preventDefault();
  var role_name;
  if(reactLocalStorage.get('role') ==='ROLE_OPERATOR' || reactLocalStorage.get('role') ==='ROLE_OPERATOR_INT')
  {
    role_name="ROLE_ADMIN"
  }
  if(reactLocalStorage.get('role') ==='ROLE_ADMIN')
  {
    role_name="ROLE_SUBADMIN"
  }

  var x=this;
  var token=reactLocalStorage.get('accessToken');
  var mobile=this.state.mobile_number.replace('+','')
  var user;
  if(this.state.showsub == true){
     user = {
      'firstName': this.state.firstName,
      'lastName': this.state.lastName,
      'email': this.state.email,
      'password':this.state.password,
      'role_name':role_name,
      'mobile_number':mobile,
      'land_line':this.state.land_line,
      'active':this.state.account_status,
      'sender_ids':JSON.stringify(senders),
      'userName':this.state.userName
    };
  }
  else
  {
      user = {
    'firstName': this.state.firstName,
    'lastName': this.state.lastName,
    'email': this.state.email,
    'password':this.state.password,
    'role_name':role_name,
    'mobile_number':mobile,
    'land_line':this.state.land_line,
    'expiry':this.state.expiry,
    'active':this.state.account_status,
    'weight':this.state.weight,
    'sender_ids':JSON.stringify(senders),
    'userName':this.state.userName
  };
  }
 
  var data=user;
  var token=reactLocalStorage.get('accessToken');
  var ip=API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;
  if(ip.includes(s2))
  {
    apiBaseUrl = API_BASE_URL + "/core/user/rest/auth/"+reactLocalStorage.get('user_id_login')+"/signup";
  }
  else
  {
   apiBaseUrl = API_BASE_URL+"/core/user/rest/auth/"+reactLocalStorage.get('user_id_login')+"/signup";
  }
  var headers = {
   'Content-Type': 'application/json',
   'token':token
    }
  axios.post(apiBaseUrl,data,{headers: headers}).then(function (response)
  {

  if(response.data.status === 'success')
  {
    x.setState({user_ids :response.data.result.id}) 
 toast({
    type: 'success',
    title: i18n.t('success.label'),
    description:response.data.status,
    animation: 'bounce',
    time: 3000,
   
});
x.setState({modalIsOpen: true});

  }
  else if(response.data.status == 'falid')
 {
  toast({
    type: 'warning',
    title: i18n.t('warning.label'),
    description: response.data.result.errorReposne,
    animation: 'bounce',
    time: 3000,
   
});
if(response.data.result.errorReposne == 'Password does not meet complexity requirements or contains username')
{
  document.querySelector(".modalIsOpenError").style = "display:block";
    document.querySelector(".fixed_header").style = "z-index:-1";
}
 }
  else if(response.status === 204){
  toast({
    type: 'warning',
    title: i18n.t('warning.label'),
    description: response.data.result.errorReposne,
    animation: 'bounce',
    time: 3000,
   
});


  }
  else{
  console.log("Something wrong");
  toast({
    type: 'warning',
    title: i18n.t('warning.label'),
    description: response.data.result.errorReposne,
    animation: 'bounce',
    time: 3000,
   
});

  }
  })
  .catch(function (error) {
  console.log(error);
  toast({
    type: 'error',
    title: i18n.t('error.label'),
    description:i18n.t('Something_wrong.label'),
    animation: 'bounce',
    time: 5000,

});
  });
 // document.querySelector('.step_one').style = 'display:none';
 // document.querySelector('.steps_two').style = 'display:block';
}
confirmRequest =()=>{
  this.setState({modalIsOpen: false});
  document.querySelector('.step_one').style = 'display:none';
  document.querySelector('.steps_two').style = 'display:block';
}
backtwo =()=>{
  document.querySelector('.step_one').style = 'display:block';
  document.querySelector('.steps_two').style = 'display:none';
}
handleOnChange=(value)=> {
  this.setState({ mobile_number: value })
  
}
  render() {
  return (
    <div className="big_div">
    <Menutest/>
    <div className="actionMenu">
    <div className="add_form">
    <MDBContainer>
      <MDBRow>
        <MDBCol md="6">
          <MDBCard className="add_card">
            <MDBCardBody>
              <form onSubmit={this.handleSubmit} className="form_add_form">
              <div className="step_one">
        
                {this.state.superOperator ? (
                           <p className="h4 text-center py-4 text_style green_color"> {i18n.t('Add_Admin.label')}</p>
                          ) : (
                            <p className="h4 text-center py-4 text_style green_color"> {i18n.t('Add_Sub_Admin.label')}</p>

                          )}
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                  {i18n.t('First_Name.label')}
                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="name"
                  onChange={this.handleChange}
                />
                <br />
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                 
                  {i18n.t('Family_Name.label')}
                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="lname"
                  onChange={this.handleChangelname}
                />
                <br />
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                 
                  {i18n.t('User_name.label')}
                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="lname"
                  onChange={this.handleChangeusername}
                />
                <br />

                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                  
                  {i18n.t('Password.label')}
                </label>
                <input
                  type="password"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="password"
                  onChange={this.handleChangepassword}
                />
                <br />
                <div style={{display:this.state.showsub ?'none':'block'}}>
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                  
                  {i18n.t('expiry_date.label')}
                </label>
                <input
                  type="date"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="birthday"
                  onChange={this.handleChangeexpiry}
                />
                <br />
                </div>
                <label
                  htmlFor="defaultFormCardEmailEx"
                  className="grey-text font-weight-light"
                >
                  
                  {i18n.t('Email.label')}
                </label>
                <input
                  type="email"
                  id="defaultFormCardEmailEx"
                  className="form-control"
                  name="email"
                  onChange={this.handleChangeemail}
                />
                <br />

                <label
                  htmlFor="defaultFormCardEmailEx"
                  className="grey-text font-weight-light"
                >
                  
                  {i18n.t('Mobile_Number.label')}
                </label>

                <ReactPhoneInput defaultCountry={'jo'} onlyCountries={["jo"]} value={this.state.mobile_number} onChange={this.handleOnChange} excludeCountries={["il"]}/>

              
                <br />

                <label
                  htmlFor="defaultFormCardEmailEx"
                  className="grey-text font-weight-light"
                >
                  
                  {i18n.t('landline.label')}
                </label>
                <input
                  type="number"
                  id="defaultFormCardEmailEx"
                  className="form-control"
                  name="email"
                  onChange={this.handleChangelandline}
                />
                <br />
                <label
                            htmlFor="defaultFormCardNameEx"
                            className="grey-text font-weight-light"
                        >
                        
                        {i18n.t('Sender_ID.label')}
                        </label>
                  
                        <Select
                          isMulti
                          placeholder='Select ...'
                          fluid
                          search
                          selection
                          options={countryOptions}
                          onChange={this.onChangesenderid.bind(this)}
                          className="sender_value"
                        />
                    <br/>

                <div style={{display:this.state.showsub ?'none':'block'}}>
                <label
                  htmlFor="defaultFormCardEmailEx"
                  className="grey-text font-weight-light"
                >
                  
                  {i18n.t('weight.label')}
                </label>
                <input
                  type="number"
                  id="defaultFormCardEmailEx"
                  className="form-control"
                  name="email"
                  onChange={this.handleChangeweight}
                />
                <br />

         </div>
         <div className="modalIsOpenError" style={{display:'none'}}>
                  <p
                    className="details_type"
                    style={{
                      color:'red',
                      textAlign: this.state.isArabic ? "right" : "",
                      marginRight: this.state.isArabic ? "2%" : ""
                    }}
                  >
                    {i18n.t("password_title.label")}
                  </p>
                
                  <br/>
                  <p
                    className="details_type"
                    style={{
                      color:'red',
                      textAlign: this.state.isArabic ? "right" : "",
                      marginRight: this.state.isArabic ? "2%" : ""
                    }}
                  >
                    {i18n.t("password_point1.label")}
                  </p>
                  <br/>
                  <p
                    className="details_type"
                    style={{
                      color:'red',
                      textAlign: this.state.isArabic ? "right" : "",
                      marginRight: this.state.isArabic ? "2%" : ""
                    }}
                  >
                    {i18n.t("password_point2.label")}
                  </p>
                  <br/>
                  <p
                    className="details_type"
                    style={{
                      color:'red',
                      textAlign: this.state.isArabic ? "right" : "",
                      marginRight: this.state.isArabic ? "2%" : ""
                    }}
                  >
                    {i18n.t("password_point3.label")}
                  </p>
                  <br/>
                  <p
                    className="details_type"
                    style={{
                      color:'red',
                      textAlign: this.state.isArabic ? "right" : "",
                      marginRight: this.state.isArabic ? "2%" : ""
                    }}
                  >
                    {i18n.t("password_point4.label")}
                  </p>
                  <br/>
                  <p
                    className="details_type"
                    style={{
                      color:'red',
                      textAlign: this.state.isArabic ? "right" : "",
                      marginRight: this.state.isArabic ? "2%" : ""
                    }}
                  >
                    {i18n.t("password_point5.label")}
                  </p>
                  <br/>
                  <p
                    className="details_type"
                    style={{
                      color:'red',
                      textAlign: this.state.isArabic ? "right" : "",
                      marginRight: this.state.isArabic ? "2%" : ""
                    }}
                  >
                    {i18n.t("password_point6.label")}
                  </p>

        </div>
        <br/>
                <Checkbox label= {i18n.t('active.label')} style={{width:'20%'}} onClick={this.enable}  style={{ width: '34%'}} defaultChecked/>


                  <div className="text-center py-4 mt-3">
                  <Button className="submit_btn_green">

                    <MDBBtn color="cyan"  onClick={this.back}>
                    {i18n.t('Back.label')}

                    </MDBBtn>
                    </Button>

                  <Button className="submit_btn_green">
                    <MDBBtn color="cyan"  onClick={this.opentwo}>
                    {i18n.t('Next.label')}
                    </MDBBtn>
                    </Button>

                  </div>
                  </div>
                  <SemanticToastContainer />
                  <Modal
      isOpen={this.state.modalIsOpen}
      onAfterOpen={this.afterOpenModal}
      onRequestClose={this.closeModal}
      style={customStylesstop}
      contentLabel="Example Modal"
      className="stop_modal"
     
     
>
<i class="close icon" onClick={this.closeModal} style={{float:this.state.isArabic? 'left' :''}}></i>
  <h2 ref={subtitle => this.subtitle = subtitle} className="report_title_stop" style={{textAlign:this.state.isArabic? 'right' :'',marginRight:this.state.isArabic ? '2%':''}}>{i18n.t('Are_you_sure_you_want_to_assign_balance.label')}</h2>
  <div>
  <Button  onClick={this.closeModal} className="close_report_stop">{i18n.t('Cancel.label')}</Button>
  <Button  onClick={this.confirmRequest} className="close_report_stop">{i18n.t('confirm.label')}</Button>
  </div>
  <br/>
</Modal>
                 <div className="steps_two" style={{display:'none'}}>
                 <p className="h4 text-center py-4 text_style green_color"> {i18n.t('add_balance.label')}</p>

                 <p className="h6 black_color">{i18n.t('type.label')}</p>
                 
                <Select
                          fluid
                          search
                          selection
                          options={balance_type}
                          onChange={this.onChangetype.bind(this)}
                        />
                <br />


                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                >
                 
                  {i18n.t('balance.label')}
                </label>
                <input
                  type="number"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="balance"
                  onChange={this.handleChangebalance}
                />
                <br />
       
                   
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light"
                  style={{display:'none'}}
                >
                  
                  {i18n.t('billing_code.label')}
                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="billing_code"
                  onChange={this.handleChangebillingcode}
                  style={{display:'none'}}
                />
                <br />

                <Checkbox label= {i18n.t('enable.label')} style={{width:'20%',display:'none'}} onClick={this.enable2} id="1" style={{ width: '34%'}} defaultChecked/>

                 <div className="text-center py-4 mt-3">
                  <Button className="submit_btn_green">

                    <MDBBtn color="cyan"  onClick={this.backtwo}>
                    {i18n.t('Back.label')}

                    </MDBBtn>
                    </Button>

                  <Button className="submit_btn_green">
                    <MDBBtn color="cyan" type="submit">
                    {i18n.t('Submit.label')}
                    </MDBBtn>
                    </Button>
                 </div>

                 </div>
              </form>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    </div></div></div>
  );
}
};
const mapStateToProps = (state)=>{
  return {...state}
}
export default connect(mapStateToProps) (AddForm);

